/* @flow */
import * as React from 'react';
import { css, names } from 'linaria';

import { Image } from './core';
import Links from '../../data/Links';
import UserAgent from '../../utilities/UserAgent';

function AppStoreBadges({
  align = 'center',
  exclude = [],
}: {
  align?: 'left' | 'center',
  exclude?: string[],
}) {
  let badges = [];

  if (UserAgent.ios || !UserAgent.android) {
    if (!exclude.includes('ios')) {
      badges.push(
        <a href={Links.AppleAppStore}>
          <Image src={require('../../assets/images/app-store-badge.svg')} />
        </a>
      );
    }
  }

  if (UserAgent.android || !UserAgent.ios) {
    if (!exclude.includes('android')) {
      badges.push(
        <a href={Links.GooglePlayStore}>
          <Image src={require('../../assets/images/google-play-badge.svg')} />
        </a>
      );
    }
  }

  return (
    <div className={names(Styles.Container, AlignStyles[align])}>
      {badges.map((badge, i, arr) => {
        return (
          <div className={names(Styles.Badge, i >= arr.length - 1 ? Styles.LastBadge : {})} key={i}>
            {badge}
          </div>
        );
      })}
    </div>
  );
}

const AlignStyles = {
  left: css`
    justify-content: flex-start;
  `,
  center: css`
    justify-content: center;
  `,
};

const Styles = {
  Container: css`
    display: flex;
    flex-direction: row;
    margin-top: 24px;
  `,
  Badge: css`
    margin-right: 16px;
  `,
  LastBadge: css`
    margin-right: 0;
  `,
};

export default AppStoreBadges;



// WEBPACK FOOTER //
// ./src/ui/components/AppStoreBadges.js